import Base from 'app/views/base';
import LoaderView from 'app/views/loader_view';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,

  initialize({ title, ListItemView, contextWhere, fetch = true }) {
    this.title = title;
    this.ListItemView = ListItemView;
    this.contextWhere = contextWhere;
    this.fetch = fetch;

    this.listenTo(this.collection, 'sync', this.render);
    this.listenTo(this.collection, 'remove', this.render);

    this.addSubview('loader', '#loader', new LoaderView({ collection: this.collection }));

    if (this.fetch) this.collection.fetch({ reset: true });
  },

  beforeRender() {
    this.collection.each((model) => {
      const id = this.computeId(model.id);
      this.addSubview(
        id,
        `#${id}`,
        new this.ListItemView({
          model, collection: this.collection,
        }),
      );
    });
  },

  computeId(id) {
    return `item_${id}`;
  },

  context() {
    return {
      title: this.title,
      firstFetchSuccess: this.collection.firstFetchSuccess,
      collection: this.contextWhere ? this.collection.where(this.contextWhere) : this.collection.models,
    };
  },
});



// WEBPACK FOOTER //
// ./app/components/panel_list/index.js